import React, { useState } from "react";
import SafetyNotes from './SafetyNotes';
import SafetySliders from './SafetySliders';
import { Grid } from '@material-ui/core';
import SafetyCategoryOptions from "./SafetyCategoryOptions";

const SafetyCategoryNoHistory = (props) => {
    const { category, handleCategoryChange, handleNotesChange, index } = props
    const [fields, setFields] = useState(category.subCategories)
    
    const handleFieldsChange = (event, value, name) => {
        setFields(fields.map((field) => {
            field.name === name && (field.value = value);
            return field;
        }))
        handleCategoryChange(event, value, name, category.name)
    }
    const handleLocalNotesChange = (newNotes, category) => {
        handleNotesChange(newNotes, category)
    }

    return (
        <div className= {category.name == 'Tires'? "categoryTiresNH" : "categoryNH"}>
            <Grid container className="safety-categories-grid gap-y-8 pb-8" item xs={12} sm={12}>
                <Grid item xs={12} sm={9} className="pr-8">
                    <SafetyCategoryOptions
                        key={"SafetyCategoryOptions" + category.name}
                        name={category.name}
                        subCategories={category.subCategories}
                        index={index}
                    />
                </Grid>
                <Grid item container xs={12} sm={3} className='sliders' style= {{flexDirection : "column", justifyContent: "flex-end", alignItems: "center"}}>
                    <SafetySliders
                        key={"SafetySliders" + category.name}
                        fields={category.subCategories}
                        handleChange={handleFieldsChange}
                        index={index}
                    />                    
                </Grid>
                <Grid item xs={12} sm={9} className='notes pr-8'>
                    <SafetyNotes
                        key={"SafetyNotes" + category.name}
                        handleChange={handleLocalNotesChange}
                        title="Notes"
                        notes={category.notes}
                        category={category.name}
                        index={index}
                    />
                </Grid>

            </Grid>
        </div>
    )
}
export default SafetyCategoryNoHistory
